import { Pipe, PipeTransform } from '@angular/core';

import { hasUserProduct } from '../constants/constants';
import { ShowAllProductsSelected } from '../models/show-all-products-selected.interface';

@Pipe({ name: 'hasUserProduct', standalone: true })
export class HasUserProductPipe implements PipeTransform {
  transform(
    section: string,
    areAllProductsSelected: ShowAllProductsSelected,
    userServiceUserData: any,
    productId
  ): boolean {
    return hasUserProduct(
      section,
      areAllProductsSelected,
      userServiceUserData,
      productId
    );
  }
}
